import React from 'react'
import { Link } from 'react-router-dom'
import { AiFillTwitterCircle, AiFillInstagram } from 'react-icons/ai'
import { MdFacebook } from 'react-icons/md'
import { BsLinkedin } from 'react-icons/bs'

const Logo = '/images/melody_ai_logo.png'

const Footer = () => {
    return (
    
<footer class="p-4 mt-20 bg-zinc-800 min-h-[50vh] bg-cover bg-center sm:p-6">
    <div class="md:flex md:justify-between">
        <div class="mb-6 md:mb-0">
            <Link to="/" class="flex items-center">
                <span className="sr-only">Melody AI</span>
                <img src={Logo} alt='Melody AI logo'/>
            </Link>
            <div class="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
            <a href="/" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                <AiFillTwitterCircle className='social' size={40} />
                <span class="sr-only">Twitter page</span>
            </a>
            <a href="/" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                <MdFacebook className='social' size={40} />
                <span class="sr-only">Facebook page</span>
            </a>
            <a href="/" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                <AiFillInstagram className='social' size={40} />
                <span class="sr-only">Instagram page</span>
            </a>
            <a href="/" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                <BsLinkedin className='social' size={40} />
                <span class="sr-only">LinkedIn account</span>
            </a>
        </div>
        </div>
        <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
            <div>
                <h2 class="mb-3 text-sm font-bold text-white uppercase dark:text-white">Solutions</h2>
                <ul class="text-gray-300 dark:text-gray-400">
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Anomaly Detection</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Forecasting & Planning</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Fraud & Security</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Marketing & Sales</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Predictive Modeling</a>
                    </li>
                </ul>
            </div>
            <div>
                <h2 class="mb-3 text-sm font-bold text-white uppercase dark:text-white">Resources</h2>
                <ul class="text-gray-300 dark:text-gray-400">
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Blog</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Documentation</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Events</a>
                    </li>
                    <li class="mb-2">
                        <a href="/" class="hover:text-purple-600">Resource Library</a>
                    </li>
                </ul>
            </div>
            <div>
                <h2 class="mb-3 text-sm font-bold text-white uppercase dark:text-white">Company</h2>
                <ul class="text-gray-300 dark:text-gray-400">
                    <li class='mb-2'>
                        <a href="/" class="hover:text-purple-600 ">About Us</a>
                    </li>
                    <li class='mb-2'>
                        <a href="/" class="hover:text-purple-600 ">Contact</a>
                    </li>
                    <li class='mb-2'>
                        <a href="/" class="hover:text-purple-600 ">Careers</a>
                    </li>
                    <li class='mb-2'>
                        <a href="/" class="hover:text-purple-600">Press</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
    <div class="sm:flex sm:items-center sm:justify-between">
        <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2023 <a href="/" class="hover:text-purple-600">Octave Incorporations™</a>. All Rights Reserved.
        </span>
    </div>
</footer>

    )
}

export default Footer